<template>
  <div id="app" class="bg-light min-vh-100">
    <nav class="navbar navbar-dark bg-primary shadow-sm mb-5">
      <div class="container">
        <span class="navbar-brand fw-bold">Jobfinder</span>
      </div>
    </nav>

    <div class="container">
      <div class="row justify-content-center mb-5 text-center">
        <div class="col-lg-7">
          <h1 class="display-5 fw-bold mb-3">Get Your Dream Job</h1>
          <div class="input-group input-group-lg shadow-sm">
            <input 
              v-model="query" 
              type="text" 
              class="form-control" 
              placeholder="Job title, keywords, or company..."
              @keyup.enter="searchJobs"
            >
            <button class="btn btn-primary px-4" @click="searchJobs">Search</button>
          </div>
        </div>
      </div>

      <div v-if="loading" class="text-center my-5">
        <div class="spinner-grow text-primary" role="status"></div>
        <p class="text-muted mt-3">Scanning thousands of job boards...</p>
      </div>

      <div v-else class="row">
        <div v-for="job in jobs" :key="job.job_id" class="col-md-6 col-lg-4 mb-4">
          <div class="card h-100 border-0 shadow-sm hover-shadow">
            <div class="card-body d-flex flex-column">
              <div class="d-flex align-items-center mb-3">
                <img 
                  v-if="job.employer_logo" 
                  :src="job.employer_logo" 
                  alt="logo" 
                  style="width: 45px; height: 45px; object-fit: contain;"
                  class="me-3 rounded border p-1 bg-white"
                >
                <div>
                  <h6 class="card-title mb-0 fw-bold">{{ job.job_title }}</h6>
                  <small class="text-primary">{{ job.employer_name }}</small>
                </div>
              </div>

              <p class="card-text text-secondary small">
                📍 {{ job.job_city || 'Remote' }}, {{ job.job_country }}<br>
                📅 Posted: {{ formatDate(job.job_posted_at_datetime_utc) }}
              </p>
              
              <a :href="job.job_apply_link" target="_blank" class="btn btn-outline-primary mt-auto w-100">
                View & Apply
              </a>
            </div>
          </div>
        </div>

        <div v-if="!loading && jobs.length === 0" class="text-center py-5">
          <p class="lead text-muted">No jobs found for "{{ query }}".</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'App',
  data() {
    return {
      query: 'Frontend Developer',
      jobs: [],
      loading: false,
      // Accessing the Vue CLI environment variable
      apiKey: 'e34f12caf4msh2ca0d3476bfde53p11a591jsnf7ffda12e4b0'
    };
  },
  methods: {
    async searchJobs() {
      if (!this.query) return;
      this.loading = true;
      
      try {
        const response = await axios.get('https://jsearch.p.rapidapi.com/search', {
          params: {
            query: this.query,
            page: '1',
            num_pages: '1',
            remote_jobs_only: 'true'
          },
          headers: {
            'x-rapidapi-key': this.apiKey,
            'x-rapidapi-host': 'jsearch.p.rapidapi.com'
          }
        });
        this.jobs = response.data.data;
      } catch (error) {
        console.error("API Error:", error);
        alert("Failed to load jobs. Ensure your API key is correct in .env");
      } finally {
        this.loading = false;
      }
    },
    formatDate(dateString) {
      if (!dateString) return 'Recent';
      const date = new Date(dateString);
      return date.toLocaleDateString();
    }
  },
  mounted() {
    this.searchJobs();
  }
};
</script>

<style>
.hover-shadow:hover {
  transform: translateY(-5px);
  transition: all 0.3s ease;
  box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
}
</style>